import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app';
import { shouldRedirectToSignUp } from '../utils/should-redirect-to-sign-up';
import { PATH_SIGN_UP } from '../common/constants/paths';

export default defineNuxtRouteMiddleware(() => {
  const { data } = useAuth();
  const $auth = data.value ?? null;

  if (shouldRedirectToSignUp($auth)) {
    return navigateTo({ path: PATH_SIGN_UP });
  }
});
